import { Load } from '.';
import { RatingQuestionAnswer } from './rating-question-answer';

export interface RemoveCarrierData {
  load: Load;
  ratingQuestionAnswer: RatingQuestionAnswer;
}
